import { PageShell, Block } from "./PageShell";
import { BRAND } from "../data/content";

export default function Privacy() {
  return (
    <PageShell
      title="Privacy Policy"
      intro="Your privacy is the foundation of HEARD. This page explains, in plain language, how we protect you."
    >
      <Block heading="Anonymous participation">
        <p>HEARD is anonymous by design. You participate without your real name attached, so you can be honest without fear of judgment. We never require you to build a public profile.</p>
      </Block>
      <Block heading="We never sell your data">
        <p>Your story is not a product. We do not sell, rent, or trade your personal information to advertisers or third parties — ever.</p>
      </Block>
      <Block heading="What we collect">
        <p>During the beta, we collect only what's needed to invite you and improve the experience — such as the email and device you share when signing up. Beta signup details are stored securely and used solely to contact you about HEARD.</p>
      </Block>
      <Block heading="Community moderation">
        <p>Real people help keep conversations safe and supportive. Content that violates our Community Guidelines may be removed to protect the warmth of every space.</p>
      </Block>
      <Block heading="Your choices">
        <p>You decide what you share, what you see, and how you participate. To request removal from our beta list, email <a className="text-sage-deep underline" href={`mailto:${BRAND.email}`}>{BRAND.email}</a>.</p>
      </Block>
      <p className="text-sm text-ink/50">This is a beta privacy summary and will be expanded before public launch.</p>
    </PageShell>
  );
}
